module.exports = __webpack_public_path__ + "static/img/IMG_20240326_112016.755f02f1.jpg";